import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { User } from 'js/liswp/Sidebar/hooks/types';

import UserAvatar from './UserAvatar';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-8, 8px);
  align-self: stretch;
`;

const Metadata = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

const AuthorName = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-xs-4, 4px);
`;

const Institution = styled.div`
  @import 'stylesheets/design_system/font';
  @include body__small;

  color: var(--text-secondary, #535366);
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
`;

type Props = {
  user: User;
  small?: boolean; // Smaller avatar
  badge?: React.ReactNode;
  footer?: React.ReactNode;
};

const UserCard: React.FC<Props> = ({ user, small, badge, footer }) => (
  <Container>
    <UserAvatar user={user} small={small} />
    <Metadata>
      <AuthorName>
        {user.url ? (
          <BodyLink size="md" href={user.url}>
            {user.displayName}
          </BodyLink>
        ) : (
          <Body size="md">{user.displayName}</Body>
        )}
        {badge}
      </AuthorName>
      <Institution>
        {[user.university, user.position].filter(Boolean).join(', ')}
      </Institution>
      {footer && <Footer>{footer}</Footer>}
    </Metadata>
  </Container>
);

export default UserCard;
